"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
/*
  Desperately needs tests to see that the cleanup works as expected

  Is not very efficient when removing subscribers but we don't expect there to be many subscribers
  at once.
*/
var Observable = /** @class */ (function () {
    function Observable(_value, settings, logMessageOnUpdate) {
        if (settings === void 0) { settings = {}; }
        this._value = _value;
        this.settings = settings;
        this.logMessageOnUpdate = logMessageOnUpdate;
        this.subscribers = [];
    }
    Object.defineProperty(Observable.prototype, "readonlyObs", {
        get: function () {
            var _this = this;
            var instance = this;
            return {
                subscribe: function () {
                    var params = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        params[_i] = arguments[_i];
                    }
                    return _this.subscribe.apply(_this, params);
                },
                subscribeWithInitial: function () {
                    var params = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        params[_i] = arguments[_i];
                    }
                    return _this.subscribeWithInitial.apply(_this, params);
                },
                get value() {
                    return instance._value;
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Observable.prototype.shouldSubscribersBeNotified = function (oldValue, newValue) {
        var comparisonType = this.settings.comparisonType;
        if (comparisonType === undefined) {
            return !(0, lodash_isequal_1.default)(oldValue, newValue);
        }
        else if (comparisonType instanceof Function) {
            return comparisonType(newValue, oldValue);
        }
        else {
            switch (comparisonType) {
                case "lodashIsEqual":
                    return !(0, lodash_isequal_1.default)(oldValue, newValue);
                case "alwaysNotify":
                default:
                    return true;
            }
        }
    };
    /*
          Subscribe to updates.
  
          If an updateType is provided, the subscriber will only be notified
          if the updateType of the change matches the updateType provided.
  
          returns an unsubscribe method
      */
    Observable.prototype.subscribe = function (callback) {
        var _this = this;
        var subscriber = { callback: callback };
        this.subscribers.push(subscriber);
        return function () {
            _this.subscribers = _this.subscribers.filter(function (sub) { return sub !== subscriber; });
        };
    };
    /*
          Same as subscribe(), but also initially calls the callback-function
          once, as a way to make it easier to initiate variables.
      */
    Observable.prototype.subscribeWithInitial = function (callback) {
        callback(this.value);
        return this.subscribe(callback);
    };
    Observable.prototype.set = function (newValue) {
        this.updateWithType(newValue);
    };
    Observable.prototype.updateWithType = function (newValue) {
        var oldValue = this._value;
        this._value = newValue;
        if (this.shouldSubscribersBeNotified(oldValue, newValue)) {
            this.notify(newValue, oldValue);
        }
    };
    Observable.prototype.bindTo = function (args) {
        var _this = this;
        if ("subscribeWithInitial" in args) {
            return args.subscribeWithInitial(function (value) {
                _this.set(value);
                return true;
            });
        }
        else {
            return args.obs.subscribeWithInitial(function (value) {
                _this.set(args.convert(value));
                return true;
            });
        }
    };
    Observable.prototype.notify = function (newValue, oldValue) {
        var _this = this;
        if (this.logMessageOnUpdate) {
            console.log("Observable.notify()", {
                message: this.logMessageOnUpdate,
                newValue: newValue,
                oldValue: oldValue,
            });
        }
        var subscribers = __spreadArray([], this.subscribers, true);
        /*
          I hope that this will prevent memory leaks, i.e. when a class
          subscribes to an observable but never unsubscribes before it is destroyed.
        */
        subscribers.forEach(function (sub) {
            try {
                var res = sub.callback(newValue, oldValue);
                if (!res) {
                    _this.subscribers = _this.subscribers.filter(function (sub) { return sub !== sub; });
                }
            }
            catch (er) {
                console.error("Error in subscriber callback", er);
                _this.subscribers = _this.subscribers.filter(function (sub) { return sub !== sub; });
            }
        });
    };
    Object.defineProperty(Observable.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    return Observable;
}());
exports.Observable = Observable;
